var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.78,
    height: 27.852,
    viewBox: "0 0 39.78 27.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M38.961,4.358A4.984,4.984,0,0,0,35.455.852C32.342,0,19.89,0,19.89,0S7.438,0,4.325.819A5.086,5.086,0,0,0,.819,4.358C0,7.471,0,13.926,0,13.926s0,6.488.819,9.568A4.984,4.984,0,0,0,4.325,27c3.146.852,15.565.852,15.565.852s12.452,0,15.565-.819a4.984,4.984,0,0,0,3.506-3.506c.819-3.113.819-9.568.819-9.568s.033-6.488-.819-9.6Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M38.943,20.258,28.588,14.294V26.222Z",
    transform: "translate(-12.663 -6.332)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/you_Tube.6d8b0de83f8350c8cc0f84462b9c79b6.svg";
export { ForwardRef as ReactComponent };